import React from "react";
import { motion } from "framer-motion";

export const About = (props) => {
  return (
    <motion.section
      id="about"
      className="hp-about-section"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="container">
        {/* Image + text row */}
        <div className="row hp-about-row">
          <motion.div
            className="col-xs-12 col-md-5 hp-about-img-col"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="hp-about-img-wrap">
              <img src="img/about.jpg" className="img-responsive" alt="Transwave Shipping operations" />
              <div className="hp-about-img-badge">
                <span className="hp-about-badge-val">3+</span>
                <span className="hp-about-badge-lbl">Years of<br />Excellence</span>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="col-xs-12 col-md-7"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            <div className="hp-about-text">
              <span className="hp-about-tag"><i className="fa fa-certificate"></i> UAE Licensed &amp; Regulated</span>
              <h2>About Us</h2>
              {props.data
                ? props.data.paragraph.split('\n\n').map((para, i) => <p key={i}>{para}</p>)
                : <p>Loading...</p>}
            </div>
          </motion.div>
        </div>

        {/* Mission & Vision — separate section */}
        <div className="row mission-vision-section">
          <motion.div
            className="col-xs-12 col-md-6"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <div className="mission-box">
              <div className="mv-header">
                <div className="mv-icon"><i className="fa fa-rocket"></i></div>
                <h3>{props.data?.Mission?.title}</h3>
              </div>
              <p>{props.data?.Mission?.text}</p>
            </div>
          </motion.div>
          <motion.div
            className="col-xs-12 col-md-6"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <div className="vision-box">
              <div className="mv-header">
                <div className="mv-icon"><i className="fa fa-eye"></i></div>
                <h3>{props.data?.Vision?.title}</h3>
              </div>
              <p>{props.data?.Vision?.text}</p>
            </div>
          </motion.div>
        </div>

      </div>
    </motion.section>
  );
};
